import React from 'react';
import { formatFileSize } from '../../utils/file/file';

interface Props {
  children: number;
}

export const FileSize: React.FC<Props> = ({ children }) => (
  <div>{formatFileSize(children)}</div>
);
